export default "__VITE_PUBLIC_ASSET__2f71b921__"